import axios from "axios";
import jsonp from 'jsonp'
import qs from "qs";
const jsonpConfig = {
    beforeSend: () => { },
    complete: () => { },
};

export { jsonpConfig }
axios.defaults.withCredentials = true;
export default {
    get: (url, params = {}) => {
        return axios.get(url, params)
    },
    post: (url, params = {}) => {
        let data = new FormData();
        for (let key in params) {
            data.append(key, params[key]);
        }
        return axios.post(url, data, {
            headers: {
                'Content-type': 'multipart/form-data'
            },
            timeout: 1000 * 60
        })
    },
    jsonp: (url, params = {}, param = "callbackparam") => {
        if (url.indexOf("?") === -1) {
            url += "?"
        }
        for (let key in params) {
            url += "&" + key + "=" + encodeURIComponent(params[key]);
        }
        jsonpConfig.beforeSend();
        //返回promise对象，符合es6规范
        return new Promise((resolve, reject) => {
            jsonp(url, { param: param, timeout: 1000 * 60 }, (err, data) => {
                jsonpConfig.complete();
                if (err) {
                    ((err) => {
                        reject(err);
                    })(err);
                } else {
                    if (data.length > 0) {
                        data = data[0];
                    }
                    ((data) => {
                        resolve(data);
                    })(data);
                }
            });
        });
    }
}